import React, { FC, ReactElement } from 'react';
import styled from 'styled-components';
import { forTablet } from '@westwing/ui-kit/breakPoints';
import { StyledArrowIcon } from '@westwing/ui-kit/Icons/StyledIcons';
import { useLooksTracking } from '../hooks/useLooksTracking';
import HybridLink from 'Client/components/Generic/Links/HybridLink';
import { TrackLooksActions } from 'Common/ga/types';

const StyledLink = styled(HybridLink)`
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
`;

const StyledWrapper = styled.div`
    width: 30px;
    height: 30px;
    margin-left: 10px;

    ${forTablet`
        display: none;
    `}
`;

export interface GoBackLinkProps {
    to: string;
    isVisible: boolean;
}

const BackButton: FC<GoBackLinkProps> = ({ to, isVisible }): ReactElement => {
    const { LLP: LLPTracking } = useLooksTracking();

    const handleStyleLinkClick = () => LLPTracking.track(TrackLooksActions.LLPBackButtonClick, to);

    return (
        <StyledWrapper>
            {isVisible && (
                <StyledLink to={to} onClick={handleStyleLinkClick}>
                    <StyledArrowIcon size={8} />
                </StyledLink>
            )}
        </StyledWrapper>
    );
};

export default BackButton;
